module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/long-arrow-down.svg?5b452b0270bed3e230d9ee26659e2ced";